import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SpinnerComponent } from '@epd/pattern-library';

@Component({
    selector: 'craig-placeholder',
    standalone: true,
    imports: [SpinnerComponent],
    templateUrl: './placeholder.component.html',
    styleUrl: './placeholder.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaceHolderComponent {}
